import { Type } from '@angular/core';

import {
    CasinocoreErrorHandlerComponent,
    CozybingoQuickinfoDirectComponent,
    MobileSearchComponent,
    QuickInfoDirectComponent,
    ThumbnailSectionComponent,
} from '@casinocore/platform';
import { SkeletonComponent } from '@frontend/casino-ui';

import { ArcadeNavigationSectionComponent } from '../arcade-navigation-section';
import { CasinoGamesSectionComponent } from '../casino-games-section';
import { DynamicPlayerTitleComponent } from '../dynamic-player-title/dynamic-player-title.component';
import { GamesNavSectionComponent } from '../games-nav-section';
import { GamesSubNavSectionComponent } from '../games-sub-nav-section';
import { InstagramSectionComponent } from '../instagram-section';
import { NavSectionComponent } from '../nav-section';
import { SubNavSectionComponent } from '../sub-nav-section';
import { TeaserSectionComponent } from '../teaser-section/teaser-section.component';

export interface Widget {
    componentName: string;
    component: any;
    inputs: {
        lobbyType: string;
        currentProduct: string | undefined;
        data: any;
    };
    isTeaser: boolean;
    isLazyLoad: boolean;
}

export enum WidgetComponent {
    NavSectionComponent = 'NavSectionComponent',
    TeaserSectionComponent = 'TeaserSectionComponent',
    QuickInfoDirectComponent = 'QuickInfoDirectComponent',
    MobileSearchComponent = 'MobileSearchComponent',
    CasinoGamesSectionComponent = 'CasinoGamesSectionComponent',
    GamesNavSectionComponent = 'GamesNavSectionComponent',
    SubNavSectionComponent = 'SubNavSectionComponent',
    GamesSubNavSectionComponent = 'GamesSubNavSectionComponent',
    InstagramSectionComponent = 'InstagramSectionComponent',
    ThumbnailSectionComponent = 'ThumbnailSectionComponent',
    CasinocoreErrorHandlerComponent = 'CasinocoreErrorHandlerComponent',
    CozybingoQuickinfoDirectComponent = 'CozybingoQuickinfoDirectComponent',
    DynamicPlayerTitleComponent = 'DynamicPlayerTitleComponent',
    ArcadeNavigationSectionComponent = 'ArcadeNavigationSectionComponent',
    SeoBoxSectionComponent = 'SeoBoxSectionComponent',
    RPFavSectionComponent = 'RPFavSectionComponent',
    RecentlyplayedGymlSectionComponent = 'RecentlyplayedGymlSectionComponent',
    ThumbnailHomeComponent = 'ThumbnailHomeComponent',
    NewsFeedSectionV2Component = 'NewsFeedSectionV2Component',
    PlayBingoBtnComponent = 'PlayBingoBtnComponent',
    NewsFeedSectionComponent = 'NewsFeedSectionComponent',
    StaticDiscoverFeedWrapperComponent = 'StaticDiscoverFeedWrapperComponent',
    GlobalJackpotTandCComponent = 'GlobalJackpotTandCComponent',
    LiveGamesSectionComponent = 'LiveGamesSectionComponent',
    GlobalJackpotContainerComponent = 'GlobalJackpotContainerComponent',
    CozyBingoWidgetComponent = 'CozyBingoWidgetComponent',
    SuperButtonSectionComponent = 'SuperButtonSectionComponent',
    PromotionsBannerSectionComponent = 'PromotionsBannerSectionComponent',
    CasinoGameSelectorSectionComponent = 'CasinoGameSelectorSectionComponent',
    GameShowHubSectionComponent = 'GameShowHubSectionComponent',
    NewGameQuickInfoComponent = 'NewGameQuickInfoComponent',
    GamingStoriesSectionComponent = 'GamingStoriesSectionComponent',
    GlobalJackpotWinnersFeedComponent = 'GlobalJackpotWinnersFeedComponent',
    ArcadeTandCComponent = 'ArcadeTandCComponent',
    ArcadeRPSectionComponent = 'ArcadeRPSectionComponent',
    ImmersiveLobbySectionComponent = 'ImmersiveLobbySectionComponent',
    LiveCasinoLoungeSectionComponent = 'LiveCasinoLoungeSectionComponent',
    SkeletonComponent = 'SkeletonComponent',
}

export const ComponentDictionary: Record<string, Type<any>> = {
    [WidgetComponent.NavSectionComponent]: NavSectionComponent,
    [WidgetComponent.TeaserSectionComponent]: TeaserSectionComponent,
    [WidgetComponent.QuickInfoDirectComponent]: QuickInfoDirectComponent,
    [WidgetComponent.MobileSearchComponent]: MobileSearchComponent,
    [WidgetComponent.CasinoGamesSectionComponent]: CasinoGamesSectionComponent,
    [WidgetComponent.GamesNavSectionComponent]: GamesNavSectionComponent,
    [WidgetComponent.SubNavSectionComponent]: SubNavSectionComponent,
    [WidgetComponent.GamesSubNavSectionComponent]: GamesSubNavSectionComponent,
    [WidgetComponent.InstagramSectionComponent]: InstagramSectionComponent,
    [WidgetComponent.ThumbnailSectionComponent]: ThumbnailSectionComponent,
    [WidgetComponent.CasinocoreErrorHandlerComponent]: CasinocoreErrorHandlerComponent,
    [WidgetComponent.CozybingoQuickinfoDirectComponent]: CozybingoQuickinfoDirectComponent,
    [WidgetComponent.DynamicPlayerTitleComponent]: DynamicPlayerTitleComponent,
    [WidgetComponent.ArcadeNavigationSectionComponent]: ArcadeNavigationSectionComponent,
    [WidgetComponent.SkeletonComponent]: SkeletonComponent,
};

export enum ComponentProps {
    ComponentName = 'componentName',
    LobbyType = 'lobbyType',
    CurrentProduct = 'currentProduct',
    Data = 'data',
    EnableNewSkeletonUi = 'enableNewSkeletonUI',
}
